import echarts from 'echarts'
import $ from 'jquery'
// 饼状图颜色      '#16a1d9', '#246ead', '#f14646', '#ff8f2c',
let colorList31 = ['#fe8e3a', '#4cb8ff', '#099eff', '#FF5F67', '#F266AA', '#D479BC', '#468CD2',
    '#41AADF', '#6DB6FF', '#5FD5BC', '#A0D781',
    '#FAA548', '#FE775A'
];

// 饼状图1
function echartsPieOne(id, serierData) {
    let myChart = echarts.init(document.getElementById(id))
    let option = {
        tooltip: {
            trigger: 'item',
            padding: 0,
            formatter: function(params) {
                // console.log(params);
                let htmlStr = '<div class="table-tootip">'
                htmlStr += '<table><tr><td>' + params.name + '</td><td>' + params.value + '</td></tr><tr><td>占比:</td><td>' + params.percent + '%</td></tr></table></div>'
                return htmlStr;

            }
        },
        color: colorList31,
        legend: {
            orient: 'vertical',
            left: '70%',
            top: 'center',
            icon: 'rect',
            itemWidth: 8,
            itemHeight: 8,
            itemGap: 10,
            textStyle: {
                color: '#fff',
                fontSize: 13
            },
            data: []
        },

        series: [{
            type: 'pie',
            radius: ['45%', '80%'],
            center: ['55%', '55%'],
            data: serierData,
            itemStyle:  { 
                normal:  { 
                    label:  {
                        formatter: function(e) { //隐藏标示
                            // console.log(e);
                            let data = e.data;
                            if (data.value == 0) {
                                return ''
                            }
                        },
                    },
                     labelLine:  { 
                        show: false  //隐藏标示线
                    } ,
                }            
            }
        }]
    }

    myChart.setOption(option);


}

// 折线图1
// 折线图，柱状图  七日年化收益率
function echartsOne(id, xdata, isTrue, serierData, minsize = 0, ystr = '', obj, ) {

    let yScale0 = false,
        yScale1 = false;
    if (obj && obj.yScale0) {
        yScale0 = obj.yScale0;
    }
    if (obj && obj.yScale1) {
        yScale1 = obj.yScale1;
    }

    let yValue0 = '',
        yValue1 = '';
    if (obj && obj.yValue0) {
        yValue0 = obj.yValue0
    }
    if (obj && obj.yValue1) {
        yValue1 = obj.yValue1
    }

    let tooltipStr = '数据日期';
    if (obj && obj.tooltipStr) {
        tooltipStr = obj.tooltipStr;
    }

    let myChart = echarts.init(document.getElementById(id))
    let option = {
        // 提示框
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'none'
            },
            padding: 0,
            formatter: function(params) {
                var htmlStr = '<div class="table-tootip">';
                htmlStr += '<table><tr><td>' + tooltipStr + '：</td><td>' + params[0].name + '</td></tr>';
                for (let i = 0; i < params.length; i++) {
                    if (params[i].seriesIndex == 0) {
                        htmlStr += '<tr><td>' + params[i].seriesName + '：</td><td>' + params[i].value + yValue0 + ystr + '</td></tr>'
                    } else {
                        htmlStr += '<tr><td>' + params[i].seriesName + '：</td><td>' + params[i].value + yValue1 + '</td></tr>'
                    }
                }
                htmlStr += '</table></div>';
                return htmlStr;
            }
        },
        // 说明
        // legend: { 
        //     bottom: 28,
        //     icon:   "rect",
        //     itemHeight:  8,
        //     itemWidth:  8,
        //     itemGap: 35,
        //     textStyle:  { 
        //         color: '#cdcdcd'         
        //     },

        // },
        // 位置
        grid: {
            top: '10%',
            left: '5%',
            right: '8%',
            bottom: '5%',
            containLabel: true
        },

        xAxis: {
            type: 'category',
            showAllSymbol: true,

            // boundaryGap: false,
            // 去掉指示线
            axisPointer: {
                type: 'none'
            },
            //使坐标轴刻度与标签对齐
            axisTick:  {              
                alignWithLabel: false
            },
            boundaryGap: isTrue,
            // 文字颜色
            axisLabel: {
                interval: 0, // x轴坐标全部显示
                textStyle: {
                    color: '#656565',
                },
            },
            // 设置网格线
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#dcdcdc',
                    width: 1,
                    type: 'solid'
                }
            },
            // 设置区域颜色
            splitArea:  {
                show:  true,
                 areaStyle:  {
                    color:  ['#f5f5f5',  '#fff']            
                },
            },
            //y轴线颜色
            axisLine: {
                lineStyle: {
                    type: 'solid',
                    color: '#dcdcdc',
                    width: '1'
                }
            },
            zlevel:  -1,
            // 横坐标
            data: xdata
        },
        yAxis: [{
                min: minsize, //y轴的最小值
                // max: 1.004, //y轴最大值
                // interval: 20, //值之间的间隔
                type: 'value',
                name: '七日年化收益率(%)',
                nameTextStyle: { //name样式
                    // padding: [0, 0, 0, -20], // 四个数字分别为上右下左与原位置距离
                    color: "#656565",
                    fontSize: 14,
                },
                // 文字颜色
                axisLabel: {
                    formatter: '{value}' + ystr,
                    textStyle: {
                        color: '#656565'
                    },
                },
                // 设置网格线
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#dcdcdc',
                        width: 1,
                        type: 'solid'
                    }
                },
                //x轴线颜色
                axisLine: {
                    lineStyle: {
                        type: 'solid',
                        color: '#dcdcdc',
                        width: '1'
                    }
                },

            },
            {
                type: 'value',
                min: 0,
                axisLabel: {
                    formatter: '{value}'
                },
                // 文字颜色
                axisLabel: {
                    formatter: '{value}' + ystr,
                    textStyle: {
                        color: '#8c8c8c'
                    },
                },
                //y轴线颜色
                axisLine: {
                    lineStyle: {
                        type: 'solid',
                        color: '#dcdcdc',
                        width: '1'
                    }
                },
                // 设置网格线
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#252525',
                        width: 1,
                        type: 'dashed'
                    }
                },
            }
        ],
        series: serierData
    }
    myChart.setOption(option);
}

// 折线图2
function echartsTwo(id, xdata, isTrue, serierData, ystr = '', obj, yName) {
    let yScale0 = false,
        yScale1 = false;
    if (obj && obj.yScale0) {
        yScale0 = obj.yScale0;
    }
    if (obj && obj.yScale1) {
        yScale1 = obj.yScale1;
    }

    let yValue0 = '',
        yValue1 = '';
    if (obj && obj.yValue0) {
        yValue0 = obj.yValue0
    }
    if (obj && obj.yValue1) {
        yValue1 = obj.yValue1
    }

    let tooltipStr = '数据日期';
    if (obj && obj.tooltipStr) {
        tooltipStr = obj.tooltipStr;
    }

    let myChart = echarts.init(document.getElementById(id))
    let option = {
        // 提示框
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'none'
            },
            padding: 0,
            formatter: function(params) {
                var htmlStr = '<div class="table-tootip">';
                htmlStr += '<table><tr><td>' + tooltipStr + '：</td><td>' + params[0].name + '</td></tr>';
                for (let i = 0; i < params.length; i++) {
                    if (params[i].seriesIndex == 0) {
                        htmlStr += '<tr><td>' + params[i].seriesName + '：</td><td>' + params[i].value + yValue0 + ystr + '</td></tr>'
                    } else {
                        htmlStr += '<tr><td>' + params[i].seriesName + '：</td><td>' + params[i].value + yValue1 + '</td></tr>'
                    }
                }
                htmlStr += '</table></div>';
                return htmlStr;
            }
        },
        // 位置
        grid: {
            top: '10%',
            left: '5%',
            right: '8%',
            bottom: '5%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            showAllSymbol: true,
            axisPointer: { // 去掉指示线
                type: 'none'
            },
            axisTick:  {      //使坐标轴刻度与标签对齐         
                alignWithLabel: false
            },
            boundaryGap: isTrue,
            // 文字颜色
            axisLabel: {
                textStyle: {
                    color: '#656565',
                },
            },
            //y轴线颜色
            axisLine: {
                lineStyle: {
                    type: 'solid',
                    color: '#dcdcdc',
                    width: '1'
                }
            },
            zlevel:  -1,
            // 横坐标
            data: xdata
        },
        yAxis: [{
                type: 'value',
                name: yName,
                nameTextStyle: { //name样式
                    color: "#656565",
                    fontSize: 14,
                },
                // 文字颜色
                axisLabel: {
                    formatter: '{value}' + ystr,
                    textStyle: {
                        color: '#656565'
                    },
                },
                // 设置网格线
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#dcdcdc',
                        width: 1,
                        type: 'dashed'
                    }
                },
                //x轴线颜色
                axisLine: {
                    lineStyle: {
                        type: 'solid',
                        color: '#dcdcdc',
                        width: '1'
                    }
                },

            },
            {
                type: 'value',
                min: 0,
                axisLabel: {
                    formatter: '{value}'
                },
                // 文字颜色
                axisLabel: {
                    formatter: '{value}' + ystr,
                    textStyle: {
                        color: '#8c8c8c'
                    },
                },
                //y轴线颜色
                axisLine: {
                    lineStyle: {
                        type: 'solid',
                        color: '#dcdcdc',
                        width: '1'
                    }
                },
                // 设置网格线
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#252525',
                        width: 1,
                        type: 'dashed'
                    }
                },
            }
        ],
        series: serierData
    }
    myChart.setOption(option);
}


// 折线图3 精准理财组合调仓
function echartsThree(id, xdata, isTrue, serierData, ystr = '', obj, yName) {
    // 折现
    let myChart = echarts.init(document.getElementById(id))
    let option = {
        xAxis: {
            name: '波动率',
            type: 'category',
            nameGap: 5,
            data: xdata
        },
        yAxis: {
            name: '模拟年化收益率',
            type: 'value',
            axisLabel: {
                formatter: '{value} %'
            },
        },
        tooltip: {
            trigger: 'axis',
            padding: 0,
            formatter: function(params) {
                let htmlStr = '<div class="table-tootip">'
                htmlStr += '<table><tr><td>' + '可在线上点击实心圆圈进行操作' + '</td><td></td></tr><tr><td>' + '模拟年化收益率：' + '</td><td>' + params[0].data + '%' + '</td></tr><tr><td>' + '波动率：' + '</td><td>' + params[0].axisValue + '</td></tr></table></div>'
                return htmlStr;
            },
        },
        series: serierData
    }
    myChart.setOption(option);
}
export default {
    echartsPieOne,
    echartsOne,
    echartsTwo,
    echartsThree,
}
